// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found-lists-container {
  width: calc(100% - 2rem);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1 0 80%;
  margin: 0 auto;
}
.not-found-lists-icon {
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.not-found-lists-title {
  margin: 1.25rem 0 0.5rem 0;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: var(--black9);
}
@media (max-width: 768px) {
  .not-found-lists-title {
    margin-top: 1rem;
  }
}
.not-found-lists-subtitle {
  text-align: center;
  margin: 0 0 1.25rem 0;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--black5);
}
@media (max-width: 768px) {
  .not-found-lists-subtitle {
    margin-bottom: 1rem;
  }
}
.not-found-lists-button {
  padding: 0 1rem;
  white-space: nowrap;
}
@media (max-width: 768px) {
  .not-found-lists-button {
    width: 100%;
  }
}
@media (max-width: 420px) {
  .not-found-lists-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./client/components/404-2/style.scss"],"names":[],"mappings":"AAEE;EACE,wBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFJ;AAKE;EACE,0BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAHJ;AAKI;EAVF;IAWI,gBAAA;EAFJ;AACF;AAKE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAHJ;AAKI;EAVF;IAWI,mBAAA;EAFJ;AACF;AAKE;EACE,eAAA;EACA,mBAAA;AAHJ;AAKI;EAJF;IAKI,WAAA;EAFJ;AACF;AAGI;EAPF;IAQI,WAAA;EAAJ;AACF","sourcesContent":[".not-found-lists {\n\n  &-container {\n    width: calc(100% - 2rem);\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    flex: 1 0 80%;\n    margin: 0 auto;\n  }\n\n  &-icon {\n    width: auto;\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &-title {\n    margin: 1.25rem 0 .5rem 0;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 19px;\n    text-align: center;\n    color: var(--black9);\n\n    @media (max-width: 768px) {\n      margin-top: 1rem;\n    }\n  }\n\n  &-subtitle {\n    text-align: center;\n    margin: 0 0 1.25rem 0;\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--black5);\n\n    @media (max-width: 768px) {\n      margin-bottom: 1rem;\n    }\n  }\n\n  &-button {\n    padding: 0 1rem;\n    white-space: nowrap;\n\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n    @media (max-width: 420px) {\n      width: 100%;\n    }\n\n    &.ban {\n\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
